<div
  [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme"
  (mouseover)="sidebarHoverMouseIn()"
  (mouseout)="sidebarHoverMouseOut()"
>
  <div class="app-header__logo">
    <div class="logo-src"></div>
    <div class="header__pane ms-auto">
      <button
        type="button"
        class="hamburger close-sidebar-btn hamburger--elastic"
        [ngClass]="{ 'is-active': globals.toggleSidebar }"
        (click)="toggleSidebar()"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="app-sidebar-content">
    <div class="app-sidebar-scroll">
      <!-- TODO: make max-height based on screen size -->

      <overlay-scrollbars
        [defer]="true"
        class="scroll-container"
        style="max-width: 600px; max-height: 690px"
      >
        <div class="v-sidebar-menu vsm-default">
          <div class="vsm-list">
            <!-- <div class="vsm-item">
              <a routerLink="" routerLinkActive="active-item" [routerLinkActiveOptions]="{exact: true}" class="vsm-link">
                <i class="vsm-icon pe-7s-graph2"></i>
                <span class="vsm-title">{{ 'Left_Menu.DASHBOARDS' | translate }}</span>
              </a>
            </div> -->
            <div class="vsm-item" *ngIf="isRootUser">
              <a
                routerLink="/page/company-registration"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-graph"></i>
                <span class="vsm-title">{{
                  "Left_Menu.COMPANY_REGISTRATION" | translate
                }}</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="/page/user-management"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-gleam"></i>
                <span class="vsm-title">{{
                  "Left_Menu.USER_MANAGEMENT" | translate
                }}</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="/page/project-management"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-graph1"></i>
                <span class="vsm-title">{{
                  "Left_Menu.PROJECT_MANAGEMENT" | translate
                }}</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="/page/screen-management"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-graph1"></i>
                <span class="vsm-title">{{
                  "Left_Menu.SCREEN_MANAGEMENT" | translate
                }}</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="/page/change-password"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-graph1"></i>
                <span class="vsm-title">{{
                  "Left_Menu.CHANGE_PASSWORD" | translate
                }}</span>
              </a>
            </div>
          </div>
        </div>
      </overlay-scrollbars>
    </div>
  </div>
</div>
